/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useQuery } from "@tanstack/react-query";
import { getProject } from "./queryFunctions";
import { IApiExtendedParams } from "@/interfaces/Common.interface";

export const useGetProject = (params: IApiExtendedParams) => {
  if (!params.workspaceId) {
    throw new Error("Enter a valid workspaceId");
  }
  if (!params.projectId) {
    throw new Error("Enter a valid projectId");
  }
  return useQuery({
    queryKey: ["project", params.projectId],
    queryFn: () => getProject({ ...params })
  });
};
